/** Take a size in bytes and converts it to a nice string */
export type FormatFileSize = (size: number, si: boolean, dp: number) => string;

// Used on Mac
export const fileSizeSI = {
  units: ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  threshold: 1000,
  kB: 1000,
  MB: 1000 ** 2,
  GB: 1000 ** 3,
  TB: 1000 ** 4,
  PB: 1000 ** 5,
  EB: 1000 ** 6,
  ZB: 1000 ** 7,
  YB: 1000 ** 8,
};

// Used on Windows
export const fileSizeIEC = {
  units: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'],
  threshold: 1024,
  KiB: 1024,
  MiB: 1024 ** 2,
  GiB: 1024 ** 3,
  TiB: 1024 ** 4,
  PiB: 1024 ** 5,
  EiB: 1024 ** 6,
  ZiB: 1024 ** 7,
  YiB: 1024 ** 8,
};

// From https://stackoverflow.com/a/14919494/7490030
/**
 * Format bytes as human-readable text.
 *
 * @param bytes Number of bytes.
 * @param iec True to use binary (IEC), aka powers of 1024.
 *            False to use metric (SI) units, aka powers of 1000.
 * @param dp Number of decimal places to display.
 *
 * @return Formatted string.
 */
export const formatFileSize = (bytes, iec = false, dp = 0) => {
  const { threshold, units } = iec ? fileSizeIEC : fileSizeSI;

  if (Math.abs(bytes) < threshold) {
    return `${bytes} B`;
  }

  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= threshold;
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= threshold &&
    u < units.length - 1
  );

  return `${bytes.toFixed(dp)} ${units[u]}`;
};
